import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as $ from "jquery";
import * as _ from "lodash";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import swal from "sweetalert2";
import * as fromRootStore from "../../../../reducers";
import {  HttpClient } from '@angular/common/http';
import {
  ComboService,
  ExcelService,
  ReportService,
  SalesOrderService,
  Combo2Service
} from "../../../../services/index";
import { SalesInvoiceService } from "../../../../services/salesinvoice.service";
import { IfObservable } from "rxjs/observable/IfObservable";

@Component({
  selector: "partyOrderReport",
  templateUrl: "./partyOrderReport.html",
})
export class partyOrderReport {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input("params") params: any;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  @ViewChild("tbody1") tbody1;
  finyearCtrl: FormControl = new FormControl();
  seasonCtrl: FormControl = new FormControl();
  printConfig: any = {
    title: "Party Order Report",
    columns: [],
    rows: [],
  };
  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "party_name",
    orderDir: "asc",
  };
  row: any;
  data: any;
  seasonList = [];
  // totalDesign :any;
  designdata: any = { indent_no: 0, totalmtr: 0, totalamt: 0 };
  columns = [];
  party: string;
  order_no: number;
  qualityList: any;
  showsize: boolean;
  upcoming: boolean = false;
  cont: boolean = false;
  showDesign: string;
  typeList: any;
  codeList: any;
  finyearList: any;
  widthList: any[];
  sales: any = {
    party_name: "",
    party_id: "",
    so_no: "",
    so_date: "",
    level: "level",
    order_no: "",
    order_date: "",
    order_id: "",
    design_no: "",
    agent_name: "",
    season: "",
    season_id: 0,
    serial: 0,
    total: 0,
  };
  delPartyList: any;
  toggleCol = [];
  party_id: any;
  box: any;
  filter: any = {
    type: "",
    finyear: "",
    season: "",
  };
  desData: any = {
    totalmtr: 0,
    totalamt: 0,
  };
  designList: any;
  invalidList: any = [];
  exceldata: any;
  gridOptions: any;
  workOrder: any[];
  mode: string;
  saveEvent: any;
  agentList: any;
  TemppartyList = [];
  tempDataList : any;
  originalDataList : any;
  styleList = ["FORMAL","RR FORMAL","CASUAL","RR CASUAL","CLUB ","CLUBWEAR ","STYLISH FORMAL","ADAYALAM", "STRIPES"];
  varietyList : any;
  bl = [];
  partyCodeList: any;
  isLoading: boolean = false;
  isChecked: boolean = false;
  sampleList = [{ name: "YES" }, { name: "NO" }];
  colorList = [
    "lightcyan",
    "#f9eff0",
    "#3fed66",
    "lightgoldenrodyellow",
    "floralwhite",
    "#fbd4da",
    "#f2cd75",
    "lightgrey",
    "whitesmoke"
  ];

  partyList: any;
  // partyOrderno:any;
  order: any;
  sale_type: any;
  expand = true;
  to_sale_type: any;
  listSelected = [];
  level: boolean = false;
  isLoadMask: Promise<any>;
  @Input() _params: any;
  @ViewChild("widthAuto") widthAuto;
  @ViewChild("codeAuto") codeAuto;
  widthCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  // OrderNoCtrl: FormControl = new FormControl();
  qualityCtrl: FormControl = new FormControl();
  invdtControl: FormControl = new FormControl();
  parentCtrl: FormControl = new FormControl();
  constructor(
    public store: Store<fromRootStore.State>,
    private salesinvservice: SalesInvoiceService,
    private soService: SalesOrderService,
    private reportService: ReportService,
    public datePipe: DatePipe,
    public toasterService: ToasterService,
    public comboservice: ComboService,
    public combo2cervice: Combo2Service,
    private excelService: ExcelService,
    private http: HttpClient,
    // private responseType: ResponseType
  ) {
    this.row = {
      //  po_id: 0,
      party_name: "",
      so_no: "",
    };
    this.data = {
      salesList: [],
    };
    this.partyList = [];

    // this.totalDesign = [];
  }
  ngOnInit() {
    //(<any>$("#tableres")).colResizable({liveDrag:true});

    this.getColumns();
    this.loadSeasonList();
    this.getAgentList();
    this.loadVarietyList();
    // this.getSeasonList();
    this.tableScroll();
    this.toggleCol = Object.assign({}, this.columns);
  }
  ngAfterViewInit() {
    setTimeout(() => {
      $("#partyname").focus();
    }, 100);
  }
  getColumns() {
    this.columns = [
      {
        name: "SNo",
        prop: "sno",
        type: "sno",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
        sortable: false,
        toggle: true,
        cellClass: "text-center",
        headerClass: "text-center",
      },
      {
        name: "F/S",
        prop: "ftot",
        cellClass: "text-right",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
        headerClass: "text-center",
      },
      {
        name: "H/S",
        prop: "htot",
        cellClass: "text-right",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
        headerClass: "text-center",
      },
      {
        name: "GR.Tot",
        prop: "gr_tot",
        cellClass: "text-right",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
        headerClass: "text-center",
      },
      {
        name: "F/S",
        prop: "ftot",
        cellClass: "text-right",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
        headerClass: "text-center",
      },
      {
        name: "H/S",
        prop: "htot",
        cellClass: "text-right",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
        headerClass: "text-center",
      },
      {
        name: "GR.Tot",
        prop: "gr_tot",
        cellClass: "text-right",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
        headerClass: "text-center",
      },
      {
        name: "F/S",
        prop: "ftot",
        cellClass: "text-right",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
        headerClass: "text-center",
      },
      {
        name: "H/S",
        prop: "htot",
        cellClass: "text-right",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
        headerClass: "text-center",
      },
      {
        name: "GR.Tot",
        prop: "gr_tot",
        cellClass: "text-right",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
        headerClass: "text-center",
      },
    ];

    this.gridOptions = {
      columns: this.columns,
      loading: true,
      data: [],
    };
    this.toggleCol = Object.assign({}, this.columns);

    this.pageCallback({ offset: 0 });
  }
  tableScroll() {
    $(".invoiceTable").height(window.innerHeight - 400);
    $(".invoiceTable").width(window.innerWidth - 30);
  }
  onEnterKeyPressed(nextEl: string) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      setTimeout(() => {
        $("#" + nextEl).focus();
      }, 500);
    }
  }
  getSeasonList() {
    let params = {
      date: new Date().getFullYear(),
      page: 1,
      start: 0,
      limit: 100,
      type: "order",
    };
    this.comboservice.getCurrentSeason(params).then((res: any) => {
      if (res.success) {
        this.sales.season_name = res.data.season;
        this.sales.season_id = res.data.season_id;
        let today = new Date();
        this.sales.season_year = today.getFullYear();
      }
    });
     console.log(this.sales.season_id, "sesaon_detailssss")
  }
  loadSeasonList() {
    let that = this;
    that.reportService.getBrandNewSeason(this.filter).then(function (res) {
      that.seasonList = res;
      that.sales.season = that.seasonList[that.seasonList["length"] - 1].season;
      that.sales.season_id =
        that.seasonList[that.seasonList["length"] - 1].season_id;
    });
  }
  loadVarietyList() {
   let params= {
    page_from : 'Party Order'
   }
    this.combo2cervice.partyVarietyCombo({params}).then((res: any) => {
      this.varietyList = res.data;
    });
  }
  setSeasonID(){
    let season = _.filter(this.seasonList, { season_year: this.sales.season });
    this.sales.season_id = season[0]["season_id"];
    console.log(this.sales.season_id, "check sesaonnnnnnnn")
    this.getSalesParty();
  }
  getAgentList() {
    let that = this;
    that.soService.getAgentList({}).then((res: any) => {
      that.agentList = [...res];
    });
  }


  exportToExcel($event) {
    this.excelService.exportAsExcelFile(this.exceldata, this.title);
  }
  displayFinyear(comboType: string, id: number) {
    let list: any = [];
    if (comboType == "Finyear") {
      list = this.finyearList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { fin_id: id });
      return fitem["finyear"];
    }
    return "";
  }
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
  }

  onGoToNextFld($event, fld, ind) {
    let nxtInd = ind;
    let nxtRow = $("#row-" + ind).next("tr");
    if (fld == "bar" && nxtRow.length == 0) {
      let rowdetail = Object.assign({}, this.row);
      nxtInd = nxtInd + 1;
      $("#" + "bar" + "-" + nxtInd).focus();
    } else {
      setTimeout(() => {
        let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
        a.removeClass("mat-autocomplete-visible");
        $("#" + fld + "-" + nxtInd).focus();
      }, 100);
    }
  }
  onCellClick(event) {
    if (this.sales.level == "level") {
      // console.log(event.row);
      this.sales.level = "level2";
      this.party = event.row.party_name;
      this.order_no = event.row.order_no;
      this.sales.serial = event.row.sno;
      this.sales.order_no = event.row.so_no;
      this.sales.order_date = event.row.order_date;
      this.sales.party_id = event.row.party_id;
      this.sales.style = event.row.style;
      this.sales.order_id = event.row.order_id;
      this.getPartyDetails();
    }
  }
  onPrevClick() {
    if (this.sales.level == "workOrder") {
      this.sales.level == "level2";
      // this.party = event.row.party_name;
      // this.order_no = event.row.order_no;
      // this.sales.serial = event.row.sno;
      // this.sales.order_no = event.row.so_no;
      // this.sales.order_date = event.row.order_date;
      // this.sales.order_id = event.row.order_id;
      this.getPartyDetails();
    }
    if (this.sales.level == "level2") {
      this.sales.level = "level";
       this.sales.style = "";
       this.sales.variety = "";
      this.getPartyDetails();
    } else if (this.sales.level == "level") {
      this.level = false;
    }
  }
  isRowEmpty(ind) {
    let data = this.data.salesList;
    for (let i = 0; i < data.length; i++) {
      if (data[i + 1].design_no != "") {
        return true;
      } else {
        return false;
      }
    }
  }
  onDeleteRow($event, fld, ind) {
    $event.preventDefault();
    let that = this;
    swal({
      title: "Are you sure to delete this row?",
      type: "warning",
      focusCancel: true,
      showCancelButton: true,
      confirmButtonText: "Yes, Delete it!",
      cancelButtonText: "No, want to change",
    }).then(
      function () {
        if (that.data.salesList.length > 1) {
          if (that.box == "YES") {
            that.sales.boxless -= 10;
          }
          that.data.salesList.splice(ind, 1);
          // that.calctot();
          if ($("#" + this.page_id + fld + "-" + (ind - 1)).length > 0) {
            $("#" + this.page_id + fld + "-" + (ind - 1)).focus();
          } else if ($("#" + this.page_id + fld + "-" + (ind + 1)).length > 0) {
            $("#" + this.page_id + fld + "-" + (ind + 1)).focus();
          }
        }
      },
      function (dismiss) { }
    );
  }

  checkInd(evant, ind, all) {
    if (evant.target.checked) {
      this.listSelected.push(all.data.salesList[ind]);
    } else {
      for (var k = 0; k < this.listSelected.length; k++) {
        if (this.listSelected[k].barcode == all.data.salesList[ind].barcode) {
          this.listSelected.splice(k, 1);
          return;
        }
      }
    }
  }

  onGoToUpAndDown($event, fld, arrow, ind) {
    if ($(".mat-autocomplete-panel.mat-autocomplete-visible").length > 0) {
      return false;
    }
    $event.preventDefault();
    if ($("typeahead-container").length > 0) {
      return false;
    }
    if (arrow == "up") ind--;
    else ind++;

    if ($("#" + fld + "-" + ind).length > 0) {
      $("#" + fld + "-" + ind).focus();
    }
  }

  getAutoNumber() {
    let params = {
      trans_type: this.sale_type,
      date: this.datePipe.transform(new Date(), "yyyy-MM-dd"),
    };
    this.salesinvservice.getAutoNumber(params).then((res: any) => {
      this.sales.invoiceno = res.auto_no;
    });
  }

  getSalesParty() {
    let params = {
      start: 0,
      limit: 100,
      page: 1,
      season_id: this.sales.season_id
    };
    this.salesinvservice.getSalesParty(params).then((res: any) => {
      this.partyList = res;
      this.TemppartyList = res;
      this.addParty();
      // this.onSelectPartyName(this.sales.party_name);
    });
  }

  getTbodyStyle() {
    let height = 300;
    if (this.tbody1) {
      height -= this.tbody1.nativeElement.offsetHeight;
    }
    const style = {
      display: "block",
      width: "1px",
      height: height + "px",
      "overflow-y": "auto",
    };
    return style;
  }
  addParty() {
    let row = Object.assign(
      {
        party_name: "",
        so_date: "",
        so_id: "",
        party_id: "",
      },
      this.sales
    );
    // if (this.sales.party_name != "" || this.sales.so_no != "") {
    //   // row[row.size.toLowerCase()] = 1;
    //   let found = this.data.salesList.some(
    //     (el) => el.party_name === this.sales.party_name
    //   );
    //   if (!found) {
    //     this.data.salesList.push(row);
    //   } else {
    //     swal("Party name already entered");
    //   }
    // }

    // else if (this.sales.agent_name != "") {

      // let temp = this.agentList.filter(el => el.name == this.sales.agent_name);
      // let agent_id = temp[0].genLedid;

      // let party = this.TemppartyList.filter(
      //   (el) => el.agent_id === agent_id
      // );
      if (this.TemppartyList.length > 0) {
        this.TemppartyList.forEach(e => {
          row.party_name = e.name;
          row.party_id = e.genLedid
          this.data.salesList.push({...row});
        });
        
      } else {
        swal("Party names Not Exist");
      }

    // }
    var bottom = document.querySelector("#salesTbody");
    setTimeout(() => {
      bottom.scrollTop = bottom.scrollHeight;
    }, 300);
    this.sales.party_name = "";
    // this.sales.agent_name = "";

  }
  applyFilter() {
    let season = _.filter(this.seasonList, { season_year: this.sales.season });
    this.sales.season_id = season[0]["season_id"];
     console.log("get Partyderrrr", this.sales.season_id)
     this.getPartyDetails();
  

  }
  clearList() {
    this.data.salesList = [];
  }
  convertJsonToFormData(

    json: any,                            // Input JSON object

    formData: FormData = new FormData(),  // Optional FormData instance

    parentKey: string | null = null       // For handling nested objects

  ): FormData {

    for (const key in json) {

      if (json.hasOwnProperty(key)) {

        // Create the key name, handling nested objects with bracket notation

        const formKey = parentKey ? `${parentKey}[${key}]` : key;

        const value = json[key];

        if (value !== null && typeof value === 'object' && !(value instanceof File)) {

          // Recursively handle nested objects, but not File objects

          this.convertJsonToFormData(value, formData, formKey);

        } else {

          // Directly append primitive values and File objects

          formData.append(formKey, value);

        }

      }

    }

    return formData;
  
  }
   
  getPartyDetails() {
    let params;
    if ($("#upcoming").is(":checked")) {
      this.sales.level = "workOrder";
      params = {
        level: this.sales.level,
        order_no: this.sales.so_no,
        order_id: this.sales.order_id,
        order_date: this.sales.order_date,
        design_no: this.sales.design_no,
        serial: this.sales.serial,
        season_id: this.sales.season_id,
      };
    } else {
      if (this.data.salesList.length > 0) {
        if (this.sales.level == "workOrder") {
          this.sales.level = "level2";

        }
        this.level = true;
        params = Object.assign({}, this.sales);
        params = {
          start: `${this.page.offset * (this.page.limit + 1)}`,
          limit: `${this.page.limit}`,
          page: "1",
          orderColumn: `${this.page.orderBy}`,
          orderDir: `${this.page.orderDir}`,
          level: this.sales.level,
          order_no: this.sales.so_no,
          order_id: this.sales.order_id,
          order_date: this.sales.order_date,
          design_no: this.sales.design_no,
          serial: this.sales.serial,
          party_id: this.sales.party_id,
          styleName: this.sales.style,
          variety: this.sales.variety,
          season_id: this.sales.season_id
        };
        params["partyDetails"] = JSON.stringify(this.data.salesList);
     
      }
    }

    // if(params.level == 'level2'){
    //   const url = 'api/partyOrderDetails/partyOrderDetails';
    //   const formData =this.convertJsonToFormData(params);
    //   this.http
    //     .post(url, formData, { responseType: 'blob' }) // Set responseType to 'blob'
    //     .subscribe((blob) => {
    //       const url = window.URL.createObjectURL(blob);
    //       const anchor = document.createElement('a');
    //       anchor.href = url;
    //       anchor.download = 'output.xlsx'; // Set the file name
    //       anchor.click();
    //       window.URL.revokeObjectURL(url); // Clean up the URL
    //     });
    //     return
    // }
    let that = this;
    that.gridOptions = {
      loading: true,
      columns: [],
    };
    this.isLoadMask = this.salesinvservice
      .partyOrderDetails(params)
      .then(function (res: any) {
        
        if(params.level == 'level2'){
     
          res.data.forEach((element, ind) => {
            const temp = ind % 8;
            element["background"] = that.colorList[temp];
            // element.typeName == "WHStock Against Ord" ? element["color"] = that.colorList[2] : ''
          });

          // console.log("level 22222222", res.data)
         }
        that.originalDataList = res;
        that.gridOptions = {
          cols: res.cols,
          columns: res.columns,
          data: res.data,
          loading: false,
        };
        //   this.workOrder = res.workOrder;
        //   this.workOrderColumn = res.workOrderColumn;

       console.log("check Color Dat", res.data, res.columns)
        that.exceldata = that.getData(res.columns, res.data);
      });
  }

  // onSelectStyle() {
  //   if (this.sales.style && this.sales.variety) {
  //     this.tempDataList = this.originalDataList.data.filter(e => e.style == this.sales.style && e.variety == this.sales.variety);
  //   }
  //   else if (this.sales.style) {
  //     this.tempDataList = this.originalDataList.data.filter(e => e.style == this.sales.style);
  //   }

  
  //   // console.log(this.originalDataList, this.sales.style, this.sales.variety, "consoleeeeee style", this.tempDataList)
  //   for (let i = 7; i < this.tempDataList; i += 8) {
  //     this.tempDataList.splice(i, 0, {}); // Insert an empty object at the correct position
  //   }

  //   this.gridOptions = {
  //     cols: this.originalDataList.cols,
  //     columns: this.originalDataList.columns,
  //     data: this.tempDataList,
  //     loading: false,
  //   };

  //   this.exceldata = this.getData(this.originalDataList.columns, this.tempDataList);
  //   console.log(this.originalDataList, this.sales.style, this.sales.variety, "after add empty row  style", this.tempDataList)
  // }



  getData(columns, data) {
    let cols = columns;
    // let value = data;
    let rows = [],
      row,
      ind,
      type,
      val,
      rlen = data.length,
      clen = columns.length;

    for (let i = 0; i < rlen; i++) {
      let sno = i + 1;
      row = Object.assign({}, data[i]);
      let newrow = {
        Sno: sno,
      };
      for (let j = 1; j < clen; j++) {
        let type = cols[j].type,
          index = cols[j].index,
          prop = cols[j].prop,
          name = cols[j].name;

        newrow[name] = row[prop];
      }

      rows.push(newrow);
      sno++;
    }
    return rows;
  }
  displayFn(comboType: string, id: number) {
    let list: any = [];
    let that = this;
    if (comboType == "Season") {
      list = this.seasonList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { season: id });
      this.sales.season = fitem["season"];
      return fitem["season"];
    }
    return "";
  }

  oncheckemptyrow() {
    if (this.mode == "Convert" && this.listSelected.length > 0) {
      let listarray = [];
      let selarray = [];
      let that = this;
      listarray = that.data.salesList.filter(function (n) {
        return that.listSelected.indexOf(n) > -1 ? false : n;
      });
      let design1 = listarray;
      let desList1 = [];
      for (let i = 0; i < design1.length; i++) {
        if (design1[i].design_no != "") {
          desList1.push(design1[i]);
        }
      }

      selarray = desList1;
      that.data.salesList = that.listSelected;
      that.listSelected = selarray;
    }
    let design = this.data.salesList;
    let desList = [];
    for (let i = 0; i < design.length; i++) {
      if (design[i].design_no != "") {
        desList.push(design[i]);
      }
    }
    this.data.salesList = desList;
  }

  //   upcomingStock(){

  //     if($('#upcoming').is(":checked")){
  //         // this.level = false;
  //         // this.upcoming = true;
  //         // let params = {};
  //         // let that = this;
  //         that.gridOptions = {
  //           loading: true,
  //           columns: []
  //         };
  //         // this.isLoadMask = this.salesinvservice
  //         //   .upcomingStock(params)
  //         //   .then(function(res: any) {
  //             that.gridOptions = {
  //               cols: res.cols,
  //               columns: res.columns,
  //               data:  this.workOrder,
  //               loading: false
  //             };
  //         that.exceldata = that.getData(res.columns, res.data);
  //       });
  // }else{
  //     this.level = true;
  //     this.upcoming = false;
  // }

  // }

  onSelectPartyName(name) {
    // debugger;
    let partylist = _.filter(this.partyList, { name: name });
    // this.sales.agent_id = partylist[0]['agent_id'];
    this.sales.party_id = partylist[0]["genLedid"];
  }

  onSelectAgent(name) {
    console.log(name)
  }
  //     $('#so_no').focus();
  //     let params = {
  //         party_id:this.sales.party_id,
  //         party_name:name,
  //         season : this.sales.season_name,
  //         season_id :this.sales.season_id
  //     }
  //     this.salesinvservice
  //         .onSelectPartyNamePartyOrder(params)
  //         .then((res: any) => {

  //             this.partyOrderno = res;

  //         });
  // }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/report/SalesOrderReports/partyOrderReport/partyOrderReport.ts